"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentLoadingProgress = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _DocumentStyledComponents = require("./DocumentStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const classes = {
  uploadProgress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '23px'
  },
  uploadProgressDone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '23px',
    '&::before': {
      margin: '-4px 8px 0 10px',
      fontSize: '22px',
      lineHeight: '22px'
    }
  }
};
const DocumentLoadingProgress = props => {
  const {
    uploading,
    uploadFinished
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const renderLoadingProgress = () => {
    const progressSize = 16;
    const textUploading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.uploading,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.uploading,
      ...getTestIdProps('uploading-text')
    });
    const textDone = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.uploadDone,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.uploadDone
    });
    const progress = /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledProgress, {
      size: progressSize,
      ...getTestIdProps('progress-size')
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_icons.CheckHeavy, {
      sx: uploadFinished ? classes.uploadProgressDone : classes.uploadProgress,
      ...getTestIdProps('loading-progress'),
      children: [uploading ? progress : null, uploadFinished ? textDone : textUploading]
    });
  };
  const documentLoadingProgress = uploading || uploadFinished && renderLoadingProgress();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: documentLoadingProgress
  });
};
exports.DocumentLoadingProgress = DocumentLoadingProgress;